import { VideoConsultationNotificationConfiguration } from '@dreryk/egabinet-phone-notification-frontend-api';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { patientPhoneNotificationTranslationKeys } from '../../../../translations';

import { PatientPhoneNotificationVideoConsultationReminderConfigurationForm } from './PatientPhoneNotificationVideoConsultationReminderConfigurationForm';
import { PatientPhoneNotificationVideoConsultationReminderConfigurationModalConfirmButton } from './PatientPhoneNotificationVideoConsultationReminderConfigurationModalConfirmButton';
import { formInitializer } from './PatientPhoneNotificationVideoConsultationReminderConfigurationForm.utils';

const t = patientPhoneNotificationTranslationKeys.videoConsultationConfiguration.modal;

type PatientPhoneNotificationVideoConsultationReminderConfigurationModalProps = {
   videoConsultationNotificationConfiguration: VideoConsultationNotificationConfiguration;
   onClose: VoidFunction;
};

export const PatientPhoneNotificationVideoConsultationReminderConfigurationModal = (
   props: PatientPhoneNotificationVideoConsultationReminderConfigurationModalProps
): JSX.Element => {
   return (
      <Modal
         testId={'patientPhoneNotificationVideoConsultationReminderConfiguration'}
         title={t.title}
         width={ModalWidth.NORMAL}
      >
         <PatientPhoneNotificationVideoConsultationReminderConfigurationForm
            initializer={formInitializer(props.videoConsultationNotificationConfiguration)}
         >
            {({ handleSubmit }) => (
               <PatientPhoneNotificationVideoConsultationReminderConfigurationModalConfirmButton
                  onSuccess={props.onClose}
                  handleSubmit={handleSubmit}
               />
            )}
         </PatientPhoneNotificationVideoConsultationReminderConfigurationForm>

         <ModalCloseButton onClick={props.onClose} />
         <ModalCancelButton onClick={props.onClose} />
      </Modal>
   );
};
